import { endBrokerSession } from '../services/auth/brokerSession';

export async function sendOTPToEmail(email: string) {
  const response = await fetch(
    `https://${import.meta.env.VITE_AUTH0_API_DOMAIN || 'react-sample-test.us.auth0.com'}/passwordless/start`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        client_id:
          import.meta.env.VITE_AUTH0_OTP_CLIENT_ID ||
          'ZiRplULSkPEpfxWxb9zNllNbqlBGysW5',
        connection: 'email',
        send: 'code',
        email,
      }),
    },
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error_description || 'Failed to send OTP');
  }
  return data;
}

export async function verifyOTP(email: string, code: string) {
  const response = await fetch(
    `https://${import.meta.env.VITE_AUTH0_API_DOMAIN || 'react-sample-test.us.auth0.com'}/oauth/token`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        grant_type: 'http://auth0.com/oauth/grant-type/passwordless/otp',
        client_id:
          import.meta.env.VITE_AUTH0_OTP_CLIENT_ID ||
          'ZiRplULSkPEpfxWxb9zNllNbqlBGysW5',
        username: email,
        otp: code,
        realm: 'email',
        scope: 'openid profile email',
      }),
    },
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error_description || 'Failed to verify OTP');
  }
  return data; // Contains access_token, id_token
}

// Comprehensive logout function that clears all data and redirects to login
export const performLogout = async () => {
  // Revoke the broker session(s) before wiping the stored refresh tokens.
  await endBrokerSession();

  // Clear all localStorage items
  localStorage.clear();

  // Clear sessionStorage
  sessionStorage.clear();

  // Clear any cookies
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });

  // Redirect to login page using current origin (environment-aware)
  window.location.href = window.location.origin + '/login';
};
